import { useMakeMessagesActions } from "store/MakeMessagesSlice";

const useMakeMessages = () => {
  const { createMakeMessage, updateMakeMessage, deleteMakeMessage } = useMakeMessagesActions();

  return { createMakeMessage, updateMakeMessage, deleteMakeMessage };
};

export default useMakeMessages;
